module.exports = __webpack_public_path__ + "img/Speaker=Kaivalya Gandhi.9387752e.png";